import { CourseStructureCategory } from '../models/course-structure-category.model';

export class AddCourseStructureCategories {
    static readonly type = '[CourseStructureCategory] AddCourseStructureCategories';

    constructor(public payload: CourseStructureCategory[]) {}
}
